import { render, staticRenderFns } from "./HolidayForm.vue?vue&type=template&id=684d466c"
import script from "./HolidayForm.vue?vue&type=script&lang=js"
export * from "./HolidayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports